/* eslint-disable camelcase */
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS, CONTENT_STATUSES } from '../../../../utils/constants';
import { UserContentCards } from '../components/ContentApprovalComponents';
import ObjectAttributesSidePane from '../components/ObjectAttributesBox/ObjectAttributesSidePane';
import { showAlertOffer } from './DraftsSection';
import { INFLUENCERS_ENDPOINTS } from '../../../../config/api';
import axios from 'axios';
import Pagination from '../../../../../frontend/components/components/utils/Pagination';
import { Col } from 'react-bootstrap';

const LivePostsSection = () => {
  /** @type {import('../../../../reducers/offer.reducer').Offer} */
  const offer = useSelector(store => get(store, 'offer.offer'));
  const dispatch = useDispatch();

  const LIVE_USER_POSTS_PER_PAGE = 20;

  const [state, setState] = useState({
    userPosts: [],
    objectAttributeMetadata: {},
    objectAttributeValues: {},
    userPostId: null,
    sidePane: {
      open: false,
      render: false,
    },
    totalPages: 0,
    currentPage: 1,
    livePostsTotalCount: 0,
    loading: false
  });

  useEffect(() => { loadLivePostDrafts(state.currentPage) }, [offer.user_offer]);

  const changePage = useCallback((page) => { loadLivePostDrafts(page); }, [state]);

  const loadLivePostDrafts = (page) => {
    setState({ ...state, loading: true });

    axios.get(
      INFLUENCERS_ENDPOINTS.PAGINATED_USER_POST.GET(
        get(offer, 'user_offer.id', null), { page, exclude_platforms: ['other'] }
      )
    ).then(({ data }) => {
      const {
        total_pages,
        user_posts,
        total_count
      } = data;

      setState({
        ...state,
        loading: false,
        userPosts: user_posts.filter(upd => upd.platform !== 'other')
          .map(p => {
            let am_review_status = CONTENT_STATUSES.NEEDS_REVIEW;
            if (p.reviewed) {
              am_review_status = CONTENT_STATUSES.ACCEPTED;
            } else if (p.rejected) {
              am_review_status = CONTENT_STATUSES.REJECTED;
            } else if (
              Object.keys(get(p, 'user_post_object_attributes', {}))
                .some(key => {
                  const objectAttribute = p.user_post_object_attributes[key];
                  return objectAttribute.values.length === 0;
                })
            ) {
              am_review_status = CONTENT_STATUSES.NEEDS_MORE_INFORMATION;
            }
            return {
              am_review_status,
              ...p
            };
          }),
        currentPage: page,
        livePostsTotalCount: total_count,
        totalPages: total_pages
      });
    }).catch((e) => {
      setState({ ...state, loading: false });
    });
  };

  const toggleSidePane = ({
    draft,
    open = true,
    render = true,
    success = undefined,
    action = ACTIONS.CREATE,
  }) => {
    document.body.style.overflow = open ? 'hidden' : 'unset';
    let objectAttributeValues = {};
    let objectAttributeMetadata = [];
    let userPostId = null;
    if (get(draft, 'user_post_object_attributes')) {
      Object.keys(draft.user_post_object_attributes)
        .forEach(key => {
          const entry = draft.user_post_object_attributes[key];
          objectAttributeValues[key] = entry.form_values;
        });
      objectAttributeMetadata = draft.object_attribute_metadata;
      userPostId = draft.id;
    } else if (render) {
      // Keeps state for visualization
      objectAttributeMetadata = state.objectAttributeMetadata;
      objectAttributeValues = state.objectAttributeValues;
      userPostId = state.userPostId;
    }

    setState({
      ...state,
      sidePane: {
        open,
        render
      },
      objectAttributeValues,
      objectAttributeMetadata,
      userPostId,
    });
    showAlertOffer({ success, action, dispatch });

  };

  return <React.Fragment>
    <UserContentCards
      userContent={state.userPosts}
      userContentType='userPost'
      onEdit={(draft) => toggleSidePane({ draft })} 
    />
    {
      state.livePostsTotalCount > LIVE_USER_POSTS_PER_PAGE && 
      <Col xs="12" className="text-center mt-4">
        <Pagination
          currentPage={state.currentPage}
          lastPage={state.totalPages}
          fetchData={changePage}
        />
      </Col>
    }
    {
      state.sidePane.render ? 
      <ObjectAttributesSidePane
        open={state.sidePane.open}
        onRequestClose={() =>
          toggleSidePane({
            open: false,
          })
        }
        onAfterClose={(success, action = ACTIONS.UPDATE) =>
          toggleSidePane({
            open: false,
            render: false,
            success,
            action,
          })
        }
        objectAttributeMetadata={state.objectAttributeMetadata}
        objectAttributeValues={state.objectAttributeValues}
        objectAttributeEndpoint={INFLUENCERS_ENDPOINTS.OFFERS.USER_POSTS.PATCH(offer.id, state.userPostId)}
        updateType="user_post"
      /> : 
      null
    }
  </React.Fragment>;
};

export default LivePostsSection;